/* Business: FICO 644 Owner's Business
 * 2014 and 2015 have source of tax returns
 * 2016 has source of manual transcripts
 * 2017 and 2018 are interims
 *
 * Guarantor: Dan Kine
 * 2014 source tax returns
 * 2015 source manual transcripts
 * 2016 source tax returns
 * 2017 source tax returns
 * 2018 Average
 */
export default {
  rid: 314,
  lastDecisionTimestamp: null,
  cashflowDecisionable: true,
  cre: false,
  prime_rate: 3.75,
  rate_hash: '{"interest_low":"8.50%","interest_high":"8.50%","spread_low":"4.75%","spread_high":"4.75%"}',
  spread: 4.75,
  term: 120,
  amount: 124000,
  loan_info: '[{"max_loan_amount":25000,"spread":4.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":22.8}},{"max_loan_amount":49999,"spread":3.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":125000,"spread":2.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":150000,"spread":2.75,"fees":{"guaranty_1":0.017,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":350000,"spread":2.75,"fees":{"guaranty_1":0.0225,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":700000,"spread":2.75,"fees":{"guaranty_1":0.0225,"packaging":0.005,"referral":0.005,"fixed":450.0}},{"max_loan_amount":5000000,"spread":2.75,"fees":{"guaranty_1":0.02625,"guaranty_2":0.028125,"guaranty_step":1333333.33,"packaging":0.005,"referral":0.005,"fixed":450.0}}]',
  hardCreditPulled: false,
  affiliates: [
    {
      rid: 13043,
      name: 'Affiliate Three',
      borrowerType: 'affiliate'
    }
  ],
  verification: {
    use_of_fund: {
      refinance: 0,
      realEstateMortgageRefinance: 0,
      realEstatePurchase: 0,
      businessAcquisition: 0,
      inventory: 0,
      hiring: 0,
      marketing: 0,
      operationalCosts: 0,
      newEquipment: 0,
      remaining: 124000,
      total: 0,
      __typename: 'UseOfFund'
    },
    __typename: 'Verification'
  },
  cashflowData: [
    {
      source: 'derived',
      period: null,
      category: 'total_guarantor_cashflow',
      year: 2014,
      data: 428079,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_guarantor_cashflow',
      year: 2016,
      data: 91528,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_guarantor_cashflow',
      year: 2015,
      data: 123210,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_guarantor_cashflow',
      year: 2017,
      data: 120766,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_guarantor_cashflow',
      year: 2018,
      data: 342407,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_annual_personal_loan_payments',
      year: 2014,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_annual_personal_loan_payments',
      year: 2015,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_annual_personal_loan_payments',
      year: 2016,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_annual_personal_loan_payments',
      year: 2017,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_annual_personal_loan_payments',
      year: 2018,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_existing_loan_payments',
      year: 2014,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_existing_loan_payments',
      year: 2015,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_existing_loan_payments',
      year: 2016,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_existing_loan_payments',
      year: 2017,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_existing_loan_payments',
      year: 2018,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_ebitda',
      year: 2015,
      data: -3318,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_ebitda',
      year: 2014,
      data: -13523,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_ebitda',
      year: 2016,
      data: 96779,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_ebitda',
      year: 2017,
      data: -30545763,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_ebitda',
      year: 2018,
      data: -1870,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_cashflow',
      year: 2014,
      data: 414556,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_cashflow',
      year: 2016,
      data: 188307,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_cashflow',
      year: 2015,
      data: 119892,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_cashflow',
      year: 2017,
      data: -30424997,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_cashflow',
      year: 2018,
      data: 340537,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2014,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2015,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2016,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2017,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2018,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_loan_payments',
      year: 2014,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_loan_payments',
      year: 2015,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_loan_payments',
      year: 2016,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_loan_payments',
      year: 2017,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_loan_payments',
      year: 2018,
      data: 18449,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2014,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2015,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2016,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2017,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2018,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_loan_payments',
      year: 2014,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_loan_payments',
      year: 2015,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_loan_payments',
      year: 2016,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_loan_payments',
      year: 2017,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_loan_payments',
      year: 2018,
      data: 20078,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_dscr',
      year: 2014,
      data: 22.47,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_dscr',
      year: 2015,
      data: 6.5,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_dscr',
      year: 2016,
      data: 10.21,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_dscr',
      year: 2017,
      data: -1649.14,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'global_dscr',
      year: 2018,
      data: 18.46,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_dscr',
      year: 2014,
      data: 20.65,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_dscr',
      year: 2015,
      data: 5.97,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_dscr',
      year: 2016,
      data: 9.38,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_dscr',
      year: 2017,
      data: -1515.34,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_global_dscr',
      year: 2018,
      data: 16.96,
      days: 365,
      reason: null,
      resourceType: 'Loan',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    }
  ],
  financialReviewSegments: [
    {
      title: 'Cash Flow',
      key: 'cashflow',
      categories: [
        {
          key: 'ebitda',
          title: 'EBITDA',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'total_guarantor_cashflow',
          title: 'Total Guarantor Cash Flow',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'global_cashflow',
          title: 'Global Cash Flow',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    },
    {
      title: 'Loan Payments',
      key: 'loan_payments',
      categories: [
        {
          key: 'existing_business_loan_payments',
          title: 'Total Business Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'proposed_smartbiz_loan_payments',
          title: 'Proposed SmartBiz Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'total_annual_personal_loan_payments',
          title: 'Total Annual Personal Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'global_loan_payments',
          title: 'Global Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    }
  ],
  product: {
    rid: 25,
    name: 'SmartBiz - SBA',
    category: 'working_capital',
    manualMin: null,
    manualMax: null,
    term: 120,
    prime: 3,
    spread: 4.75,
    rateHash: '{"interest_low":"8.50%","interest_high":"8.50%","spread_low":"4.75%","spread_high":"4.75%"}',
    tierRates: '[{"max_loan_amount":25000,"spread":4.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":22.8}},{"max_loan_amount":49999,"spread":3.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":125000,"spread":2.75,"fees":{"guaranty_1":0.0,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":150000,"spread":2.75,"fees":{"guaranty_1":0.017,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":350000,"spread":2.75,"fees":{"guaranty_1":0.0225,"packaging":0.02,"referral":0.02,"fixed":450.0}},{"max_loan_amount":700000,"spread":2.75,"fees":{"guaranty_1":0.0225,"packaging":0.005,"referral":0.005,"fixed":450.0}},{"max_loan_amount":5000000,"spread":2.75,"fees":{"guaranty_1":0.02625,"guaranty_2":0.028125,"guaranty_step":1333333.33,"packaging":0.005,"referral":0.005,"fixed":450.0}}]',
    monthsRemainingCutoff: 6,
    productType: 'sba7a',
    livingExpense: null,
    federalTaxes: true,
    otherTaxes: true,
    __typename: 'Product'
  },
  businesses: [
    {
      rid: 414,
      borrowerType: 'oc',
      applicableYears: [
        2014,
        2015,
        2016,
        2017,
        2018
      ],
      interimYears: [
        2017,
        2018
      ],
      name: "FICO 664 Owner's Business",
      hasExistingDebt: false,
      debtSchedulePending: true,
      businessScore: 0,
      timeInBusiness: 8,
      balanceSheetUrl: '',
      profitAndLossDocumentUrls: [],
      taxReturnUrls: [],
      annualizationCoefficient: 2.118,
      interim_periods: [
        {
          to: 'December 31, 2018',
          from: 'January 01, 2018',
          year: 2018,
          __typename: 'InterimPeriod'
        }
      ],
      financial: {
        fiscal_year_end_on: '12/31/2017',
        __typename: 'Financial'
      },
      fiscalYears: [
        {
          rid: 757,
          year: 2018,
          days: 171,
          period: 'interim',
          isFullYear: false,
          isLeapYear: false,
          annualizationCoefficient: 2.118,
          __typename: 'FiscalYear'
        },
        {
          rid: 289,
          year: 2017,
          days: 365,
          period: 'interim',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 288,
          year: 2016,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: true,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 287,
          year: 2015,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 286,
          year: 2014,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 756,
          year: 2013,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        }
      ],
      cashflowData: [
        {
          source: 'manual_document',
          period: null,
          category: 'opex',
          year: 2015,
          data: 3443,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534099608,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'interest_expense',
          year: 2015,
          data: 435,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534099608,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'interest_expense',
          year: 2014,
          data: 5265,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534100322,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'officer_comp',
          year: 2014,
          data: 7777,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534100326,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'depreciation',
          year: 2014,
          data: 6535,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534100326,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'gross_revenue',
          year: 2014,
          data: 7977,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534100930,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'cogs',
          year: 2014,
          data: 33300,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534100943,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'gross_revenue',
          year: 2015,
          data: 345,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534103300,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'cogs',
          year: 2015,
          data: 3456,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534103302,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'depreciation',
          year: 2015,
          data: 2345,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534103306,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'officer_comp',
          year: 2015,
          data: 345,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534103308,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'business_use_of_home_expense',
          year: 2015,
          data: 456,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534103311,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'cogs',
          year: 2017,
          data: 3654,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144474,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'gross_revenue',
          year: 2017,
          data: 4567,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144475,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'interest_expense',
          year: 2017,
          data: 534567,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144486,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'opex',
          year: 2017,
          data: 34534678,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144487,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'depreciation',
          year: 2017,
          data: 3453435,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144487,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'officer_comp',
          year: 2017,
          data: 4534,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144488,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'interest_expense',
          year: 2018,
          data: 566,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144780,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'opex',
          year: 2018,
          data: 936,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534144940,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'gross_revenue',
          year: 2018,
          data: 37,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534145226,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'cogs',
          year: 2018,
          data: 550,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534145229,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'net_profit',
          year: 2015,
          data: -6554,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'net_profit',
          year: 2014,
          data: -25323,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'net_profit',
          year: 2017,
          data: -34533765,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'net_profit',
          year: 2018,
          data: -3069,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'cash_available_for_debt_service',
          year: 2015,
          data: -2973,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'cash_available_for_debt_service',
          year: 2014,
          data: -5746,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'cash_available_for_debt_service',
          year: 2017,
          data: -30541229,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'cash_available_for_debt_service',
          year: 2018,
          data: -1870,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'ebitda',
          year: 2015,
          data: -3318,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'ebitda',
          year: 2014,
          data: -13523,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'ebitda',
          year: 2017,
          data: -30545763,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'ebitda',
          year: 2018,
          data: -1870,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'existing_business_loan_payments',
          year: 2014,
          data: 0,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'existing_business_loan_payments',
          year: 2015,
          data: 0,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'existing_business_loan_payments',
          year: 2017,
          data: 0,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'existing_business_loan_payments',
          year: 2018,
          data: 0,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'proposed_smartbiz_loan_payments',
          year: 2014,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'proposed_smartbiz_loan_payments',
          year: 2015,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'proposed_smartbiz_loan_payments',
          year: 2017,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'proposed_smartbiz_loan_payments',
          year: 2018,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_proposed_smartbiz_loan_payments',
          year: 2014,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_proposed_smartbiz_loan_payments',
          year: 2015,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_proposed_smartbiz_loan_payments',
          year: 2017,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_proposed_smartbiz_loan_payments',
          year: 2018,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'total_business_loan_payments',
          year: 2014,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'total_business_loan_payments',
          year: 2015,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'total_business_loan_payments',
          year: 2017,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'total_business_loan_payments',
          year: 2018,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_total_business_loan_payments',
          year: 2014,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_total_business_loan_payments',
          year: 2015,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_total_business_loan_payments',
          year: 2017,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_total_business_loan_payments',
          year: 2018,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'business_dscr',
          year: 2014,
          data: -0.31,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'business_dscr',
          year: 2015,
          data: -0.16,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'business_dscr',
          year: 2017,
          data: -1655.44,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'business_dscr',
          year: 2018,
          data: -0.1,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_business_dscr',
          year: 2014,
          data: -0.29,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_business_dscr',
          year: 2015,
          data: -0.15,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_business_dscr',
          year: 2017,
          data: -1521.13,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_business_dscr',
          year: 2018,
          data: -0.09,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'interest_expense',
          year: 2016,
          data: 6565,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'depreciation',
          year: 2016,
          data: 3434,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'business_use_of_home_expense',
          year: 2016,
          data: 567,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'gross_revenue',
          year: 2016,
          data: 87654,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'cogs',
          year: 2016,
          data: 876,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_document',
          period: null,
          category: 'opex',
          year: 2016,
          data: 565,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534138643,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'interest_expense',
          year: 2016,
          data: 6565,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182162,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'depreciation',
          year: 2016,
          data: 3434,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182162,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'business_use_of_home_expense',
          year: 2016,
          data: 567,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182163,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'cogs',
          year: 2016,
          data: 876,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182163,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'gross_revenue',
          year: 2016,
          data: 87654,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182163,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'manual_transcript',
          period: null,
          category: 'opex',
          year: 2016,
          data: 565,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 1534182163,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'net_profit',
          year: 2016,
          data: 86213,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'cash_available_for_debt_service',
          year: 2016,
          data: 96779,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'ebitda',
          year: 2016,
          data: 96779,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'existing_business_loan_payments',
          year: 2016,
          data: 0,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'proposed_smartbiz_loan_payments',
          year: 2016,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_proposed_smartbiz_loan_payments',
          year: 2016,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'total_business_loan_payments',
          year: 2016,
          data: 18449,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_total_business_loan_payments',
          year: 2016,
          data: 20078,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'business_dscr',
          year: 2016,
          data: 5.25,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'stressed_business_dscr',
          year: 2016,
          data: 4.82,
          days: 365,
          reason: null,
          resourceType: 'Business',
          createdAt: 0,
          accountable: {
            name: 'Super User',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        }
      ],
      financialReviewSegments: [
        {
          title: 'Net Profit & Loss',
          key: 'net_profit_loss',
          categories: [
            {
              key: 'gross_revenue',
              title: 'Gross Revenue',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'cogs',
              title: 'Cost of Goods Sold',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'opex',
              title: 'Operating Expenses',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'net_profit',
              title: 'Net Profit',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Cash Available for Debt Service',
          key: 'cash_available_for_debt_service',
          categories: [
            {
              key: 'interest_expense',
              title: 'Interest Expense',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'depreciation',
              title: 'Depreciation',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'amortization',
              title: 'Amortization',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'officer_comp',
              title: 'Officer Compensation',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'business_use_of_home_expense',
              title: 'Business Use of Home Expense',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'expensed_debts',
              title: 'Expensed Debts',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'rent_expense',
              title: 'Rental Expense',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'cre_rent_expense',
              title: 'Rental Expense − CRE',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'business_c_corp_taxes',
              title: 'C-Corp Taxes',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'onetime_expense',
              title: 'One-time Expense',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'onetime_reduction',
              title: 'One-time Reduction',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'cash_available_for_debt_service',
              title: 'Cash Available for Debt Service',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Business Debt',
          key: 'business_debt',
          categories: [
            {
              key: 'affiliate_existing_debt',
              title: 'Existing Affiliate Loan Payments',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'existing_business_loan_payments',
              title: 'Existing Business Loan Payments',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'proposed_smartbiz_loan_payments',
              title: 'Proposed SmartBiz Loan Payments',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'stressed_proposed_smartbiz_loan_payments',
              title: 'Stressed Proposed SmartBiz Loan Payments',
              required: false,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'total_business_loan_payments',
              title: 'Total Annual Business Loan Payments',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'stressed_total_business_loan_payments',
              title: 'Stressed Total Business Loan Payments',
              required: false,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Business Debt Service Coverage Ratio',
          key: 'business_dscr',
          categories: [
            {
              key: 'business_dscr',
              title: 'Business Debt Service Coverage Ratio',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'stressed_business_dscr',
              title: 'Stressed Business Debt Service Coverage Ratio',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Global Business Categories',
          key: 'global',
          categories: [
            {
              key: 'ebitda',
              title: '${Business} EBITDA',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'existing_business_loan_payments',
              title: '${Business} Existing Loan Payments',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'affiliate_existing_debt',
              title: '${Business} Existing Loan Payments',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        }
      ],
      taxReturns: [
        {
          year: '2018',
          formName: '1065',
          rid: 290,
          __typename: 'TaxReturn'
        },
        {
          year: '2017',
          formName: '1065',
          rid: 289,
          __typename: 'TaxReturn'
        },
        {
          year: '2016',
          formName: '1065',
          rid: 288,
          __typename: 'TaxReturn'
        },
        {
          year: '2015',
          formName: '1065',
          rid: 287,
          __typename: 'TaxReturn'
        },
        {
          year: '2014',
          formName: '1065',
          rid: 286,
          __typename: 'TaxReturn'
        },
        {
          year: '2013',
          formName: '1120',
          rid: 464,
          __typename: 'TaxReturn'
        }
      ],
      balanceSheet: null,
      guarantors: [
        {
          rid: 514,
          name: 'Dan Kine',
          spouse: null,
          filing_status: 'single',
          creditDataUrls: [],
          creditScore: 0,
          jointAccountAmount: 0,
          residenceMonthlyPaymentFromCredit: null,
          scheduledMonthlyPaymentsFromCredit: 0,
          interimYears: [
            2018
          ],
          business: {
            rid: 414,
            __typename: 'Business'
          },
          taxReturnUrls: [],
          fiscalYears: [
            {
              rid: 1348,
              year: 2018,
              days: 365,
              period: 'interim',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 574,
              year: 2017,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 573,
              year: 2016,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: true,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 572,
              year: 2015,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 571,
              year: 2014,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 1346,
              year: 2013,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            }
          ],
          cashflowData: [
            {
              source: 'manual_document',
              period: null,
              category: 'social_security_benefits',
              year: 2014,
              data: 3434,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130253,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'guaranteed_payments',
              year: 2014,
              data: 3434,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130253,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_real_estate_revenue',
              year: 2014,
              data: 343434,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130253,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_mortgage_interest',
              year: 2014,
              data: 34343,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130254,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'wage_income',
              year: 2014,
              data: 43434,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130254,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'guaranteed_payments',
              year: 2016,
              data: 33535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_mortgage_interest',
              year: 2016,
              data: 35,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_real_estate_depreciation',
              year: 2016,
              data: 353,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'other_business_cashflow',
              year: 2016,
              data: 53535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_real_estate_revenue',
              year: 2016,
              data: 535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'pensions_and_annuities',
              year: 2016,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130554,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_mortgage_interest',
              year: 2015,
              data: 53535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'wage_income',
              year: 2015,
              data: 55535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'rental_real_estate_depreciation',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'guaranteed_payments',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'social_security_benefits',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'pensions_and_annuities',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534130793,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'rental_mortgage_interest',
              year: 2015,
              data: 53535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'guaranteed_payments',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'wage_income',
              year: 2015,
              data: 55535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'rental_real_estate_depreciation',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'social_security_benefits',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_transcript',
              period: null,
              category: 'pensions_and_annuities',
              year: 2015,
              data: 3535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534131359,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'wage_income',
              year: 2017,
              data: 65456,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534141760,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'guaranteed_payments',
              year: 2017,
              data: 656,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534141760,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'manual_document',
              period: null,
              category: 'social_security_benefits',
              year: 2017,
              data: 54654,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 1534141768,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'wage_income',
              year: 2018,
              data: 54808,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'guaranteed_payments',
              year: 2018,
              data: 10290,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'social_security_benefits',
              year: 2018,
              data: 20541,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'rental_real_estate_revenue',
              year: 2018,
              data: 171985,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'rental_mortgage_interest',
              year: 2018,
              data: 29304,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'rental_real_estate_depreciation',
              year: 2018,
              data: 1944,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'other_business_cashflow',
              year: 2018,
              data: 53535,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'total_income',
              year: 2014,
              data: 428079,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'total_income',
              year: 2016,
              data: 91528,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'total_income',
              year: 2015,
              data: 123210,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'total_income',
              year: 2017,
              data: 120766,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'total_income',
              year: 2018,
              data: 342407,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'net_personal_cashflow',
              year: 2014,
              data: 428079,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'net_personal_cashflow',
              year: 2016,
              data: 91528,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'net_personal_cashflow',
              year: 2015,
              data: 123210,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'net_personal_cashflow',
              year: 2017,
              data: 120766,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'net_personal_cashflow',
              year: 2018,
              data: 342407,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            }
          ],
          financialReviewSegments: [
            {
              title: 'Income',
              key: 'income',
              categories: [
                {
                  key: 'wage_income',
                  title: 'Wages',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'guaranteed_payments',
                  title: 'Guaranteed Payments',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'social_security_benefits',
                  title: 'Social Security Benefits',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_real_estate_revenue',
                  title: 'Rental Real Estate Revenue',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_mortgage_interest',
                  title: 'Rental Real Estate Interest',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_real_estate_depreciation',
                  title: 'Rental Real Estate Depreciation',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_business_cashflow',
                  title: 'Schedule C Cash Flow (side-business)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'pensions_and_annuities',
                  title: 'Pensions (recurring)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'ira_distributions',
                  title: 'IRA Distributions (recurring)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'total_income',
                  title: 'Total Income',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_personal_income',
                  title: 'Other Personal Income',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Expenses',
              key: 'expenses',
              categories: [
                {
                  key: 'rental_real_estate_expenses',
                  title: 'Rental Real Estate Expenses',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'federal_taxes',
                  title: 'Federal Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'state_taxes',
                  title: 'State Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'real_estate_taxes',
                  title: 'Real Estate Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_tax_return_adjustments',
                  title: 'Other Tax Return Adjustments',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_personal_expenses',
                  title: 'Other Personal Expenses',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'c_corp_taxes',
                  title: 'C-Corp Taxes',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'vehicle_expensed',
                  title: 'Vehicle Expensed',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'schedule_f_ebitda',
                  title: 'Schedule F EBITDA',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'home_mortgage_expense',
                  title: 'Home Mortgage Expense',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'living_expense',
                  title: 'Living Expense',
                  required: false,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'total_expenses',
                  title: 'Total Expenses',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Personal Cash Flow',
              key: 'personal_cashflow',
              categories: [
                {
                  key: 'net_personal_cashflow',
                  title: 'Net Personal Cash Flow',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Personal Debt',
              key: 'personal_debt',
              categories: [
                {
                  key: 'amex',
                  title: 'AMEX',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_property_mortgage_debt',
                  title: 'Rental Property Mortgage Debt',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'additional_personal_debt',
                  title: 'Additional Personal Debts',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'debt_already_counted',
                  title: 'Debt Already Counted',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'student_loan',
                  title: 'Student Loans',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'zero_balance_tradelines',
                  title: 'Zero Balance Tradelines',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'irs_payment_plan',
                  title: 'IRS Payment Plan',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'additional_spousal_debt',
                  title: 'Additional Spousal Debt',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'annual_personal_debt_payments',
                  title: 'Total Annual Personal Debt Payments',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            }
          ],
          taxReturns: [
            {
              year: '2018',
              formName: '1040C',
              rid: 4,
              __typename: 'TaxReturnPersonal'
            },
            {
              year: '2017',
              formName: '1040C',
              rid: 1,
              __typename: 'TaxReturnPersonal'
            },
            {
              year: '2016',
              formName: '1040C',
              rid: 5,
              __typename: 'TaxReturnPersonal'
            },
            {
              year: '2015',
              formName: '1040C',
              rid: 3,
              __typename: 'TaxReturnPersonal'
            },
            {
              year: '2014',
              formName: '1040C',
              rid: 2,
              __typename: 'TaxReturnPersonal'
            }
          ],
          personalFinancial: {
            cashInBanks: null,
            marketableSecurities: null,
            installmentLoans: null,
            creditCards: null,
            otherAssets: null,
            otherLiabilities: null,
            realEstate: null,
            lifeInsurance: null,
            retirementAccounts: null,
            otherMortgages: null,
            __typename: 'FinancialPersonal'
          },
          __typename: 'Guarantor'
        },
        {
          rid: 515,
          name: 'Joe Kleeberg',
          spouse: null,
          filing_status: 'single',
          creditDataUrls: [],
          creditScore: 0,
          jointAccountAmount: 0,
          residenceMonthlyPaymentFromCredit: null,
          scheduledMonthlyPaymentsFromCredit: 0,
          interimYears: [
            2017,
            2018
          ],
          business: {
            rid: 414,
            __typename: 'Business'
          },
          taxReturnUrls: [],
          fiscalYears: [
            {
              rid: 1349,
              year: 2018,
              days: 365,
              period: 'interim',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 579,
              year: 2017,
              days: 365,
              period: 'interim',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 578,
              year: 2016,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: true,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 577,
              year: 2015,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 576,
              year: 2014,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            },
            {
              rid: 1347,
              year: 2013,
              days: 365,
              period: 'tax',
              isFullYear: true,
              isLeapYear: false,
              annualizationCoefficient: 1,
              __typename: 'FiscalYear'
            }
          ],
          cashflowData: [
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'housing_yearly_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'scheduled_yearly_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2014,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2015,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2016,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2017,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            },
            {
              source: 'derived',
              period: null,
              category: 'annual_personal_debt_payments',
              year: 2018,
              data: 0,
              days: 365,
              reason: null,
              resourceType: 'Guarantor',
              createdAt: 0,
              accountable: {
                name: 'Super User',
                __typename: 'Administrator'
              },
              __typename: 'CashflowDatum'
            }
          ],
          financialReviewSegments: [
            {
              title: 'Income',
              key: 'income',
              categories: [
                {
                  key: 'wage_income',
                  title: 'Wages',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'guaranteed_payments',
                  title: 'Guaranteed Payments',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'social_security_benefits',
                  title: 'Social Security Benefits',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_real_estate_revenue',
                  title: 'Rental Real Estate Revenue',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_mortgage_interest',
                  title: 'Rental Real Estate Interest',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_real_estate_depreciation',
                  title: 'Rental Real Estate Depreciation',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_business_cashflow',
                  title: 'Schedule C Cash Flow (side-business)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'pensions_and_annuities',
                  title: 'Pensions (recurring)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'ira_distributions',
                  title: 'IRA Distributions (recurring)',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'total_income',
                  title: 'Total Income',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_personal_income',
                  title: 'Other Personal Income',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Expenses',
              key: 'expenses',
              categories: [
                {
                  key: 'rental_real_estate_expenses',
                  title: 'Rental Real Estate Expenses',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'federal_taxes',
                  title: 'Federal Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'state_taxes',
                  title: 'State Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'real_estate_taxes',
                  title: 'Real Estate Taxes',
                  required: true,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_tax_return_adjustments',
                  title: 'Other Tax Return Adjustments',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'other_personal_expenses',
                  title: 'Other Personal Expenses',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'c_corp_taxes',
                  title: 'C-Corp Taxes',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'vehicle_expensed',
                  title: 'Vehicle Expensed',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'schedule_f_ebitda',
                  title: 'Schedule F EBITDA',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'home_mortgage_expense',
                  title: 'Home Mortgage Expense',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'living_expense',
                  title: 'Living Expense',
                  required: false,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'total_expenses',
                  title: 'Total Expenses',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Personal Cash Flow',
              key: 'personal_cashflow',
              categories: [
                {
                  key: 'net_personal_cashflow',
                  title: 'Net Personal Cash Flow',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            },
            {
              title: 'Personal Debt',
              key: 'personal_debt',
              categories: [
                {
                  key: 'amex',
                  title: 'AMEX',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'rental_property_mortgage_debt',
                  title: 'Rental Property Mortgage Debt',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'additional_personal_debt',
                  title: 'Additional Personal Debts',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'debt_already_counted',
                  title: 'Debt Already Counted',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'student_loan',
                  title: 'Student Loans',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'zero_balance_tradelines',
                  title: 'Zero Balance Tradelines',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'irs_payment_plan',
                  title: 'IRS Payment Plan',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'additional_spousal_debt',
                  title: 'Additional Spousal Debt',
                  required: false,
                  derived: false,
                  __typename: 'FinancialReviewCategory'
                },
                {
                  key: 'annual_personal_debt_payments',
                  title: 'Total Annual Personal Debt Payments',
                  required: true,
                  derived: true,
                  __typename: 'FinancialReviewCategory'
                }
              ],
              __typename: 'FinancialReviewSegment'
            }
          ],
          taxReturns: [
            {
              year: '2017',
              formName: '1040C',
              rid: 6,
              __typename: 'TaxReturnPersonal'
            }
          ],
          personalFinancial: {
            cashInBanks: null,
            marketableSecurities: null,
            installmentLoans: null,
            creditCards: null,
            otherAssets: null,
            otherLiabilities: null,
            realEstate: null,
            lifeInsurance: null,
            retirementAccounts: null,
            otherMortgages: null,
            __typename: 'FinancialPersonal'
          },
          __typename: 'Guarantor'
        }
      ],
      outstandingLoans: [
        {
          rid: 333,
          monthlyPayment: 2000,
          monthsRemaining: 12,
          refinance: false,
          active: true,
          lender: 'test lender 1',
          principalBalance: 44442
        },
        {
          rid: 534,
          monthlyPayment: 10000,
          monthsRemaining: 24,
          refinance: true,
          active: true,
          lender: 'test lender 2',
          principalBalance: 84842
        },
        {
          rid: 444,
          monthlyPayment: 4000,
          monthsRemaining: 20,
          refinance: false,
          active: true,
          lender: 'test lender 3',
          principalBalance: 40000
        },
        {
          rid: 100,
          monthlyPayment: 20000,
          monthsRemaining: 4,
          refinance: false,
          active: true,
          lender: 'test lender 4',
          principalBalance: 4924
        }
      ],
      __typename: 'Business'
    }
  ],
  __typename: 'Loan'
}
